import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireList, AngularFireObject  } from '@angular/fire/database';


@Injectable({
  providedIn: 'root'
})
export class FirebaseDatabaseService {

  // Usamos el Servicio 'AngularFireObject' de Angular Fire para listar los datos como objeto
  appsRef: AngularFireObject<any>;
  public data:any;

  // Iniciamos el servicio 'AngularFireDatabase' de Angular Fire
  constructor(private db: AngularFireDatabase) {
  }

  // En nuestra función listarDatos() especificamos la colección de datos de Firebase Database Realtime que
  // queremos usar, la colección que usaremos se llama 'PROYECTO'
  listarDatos(query) {
    this.appsRef = this.db.object(query);
    return this.appsRef;
  }

  agregarDatos(query) {
    //{"CERVECRIA":{color: '#2196F3', estado: 1, limite: 5, nombre: 'CERVECRIA'}}
    this.appsRef.update(query)
  }
}
